import React, { useEffect, useRef } from 'react';

let showingLead = false;

function InlineLeadViewer() {
  const frameElement = useRef();
  const containerElement = useRef();

  useEffect(() => {
    window.showInlineLead = (address) => {
      if (showingLead) {
          return;
      }

      showingLead = true;

      /** @type {HTMLElement} */
      const container = containerElement.current;
      /** @type {HTMLIFrameElement} */
      const frame = frameElement.current;

      frame.src = address + window.location.search;

      setTimeout(() => {
        container.style.display = 'flex';
        window.document.scrollingElement.style.overflow = 'hidden';
      }, 100);
    };

    window.hideInlineLead = () => {
      if (showingLead === false) {
          return;
      }

      /** @type {HTMLElement} */
      const container = containerElement.current;
      /** @type {HTMLIFrameElement} */
      const frame = frameElement.current;

      showingLead = false;

      container.style.display = 'none';
      frame.src = null;
      window.document.scrollingElement.style.overflow = null;
    };

    return () => {
      window.showInlineLead = undefined;
      window.hideInlineLead = undefined;
    };
  }, []);

  const frame = (
    <iframe
      ref={frameElement}
      title="lead"
      style={{
        width: '100%',
        height: '100%',
        maxWidth: 'min(900px, 80vw)',
        maxHeight: '95vh',
        border: 'none',
        borderRadius: '10px',
        boxShadow: '0px 4px 16px #00000040',
        background: '#ffffff',
      }}
    />
  );

  return (
    <div
      ref={containerElement}
      style={{
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        position: 'fixed',
        overflow: 'hidden',
        zIndex: '1000000',
        display: 'none',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#00000020',
      }}
    >
      {frame}
    </div>
  );
}

export default InlineLeadViewer;
